export default {
    values: {
        'Visualize last BHA in the current trajectory': 'Visualize o último BHA da trajetória em construção',
        'Visualize flowback volume during connections': 'Visualize o volume de retorno durante conexões',
        'Borehole imaging visualizer': 'Visualizador de perfil de imagem de poço',
        'Visualize operational remarks': 'Visualize comentários de operação',
        'Visualize well lithology per depth': 'Visualize a litologia por profundidade do poço',
        'Visualize detected operation rig states': 'Visualize os estados de operação de sonda detectados',
        'Visualize Section view, Plan view and Survey of a well trajectory':
            'Visualize Seção vertical, Seção horizontal e Survey de uma trajetória de poço',
        'Visualize Gamma ray and resistivity logs plotted against lithology and trajectory':
            'Visualize logs de Gamma ray e resistividade de acordo com a litologia interpretada e trajetória executada',
        'Errors were found in the trajectory data, which can impact the rendering of the graph.':
            'Foram encontrados erros nos dados da trajetória, os quais podem impactar a renderização do gráfico.',
        'Errors were found that can affect the rendering of the chart':
            'Foram encontrados erros que podem afetar a renderização do gráfico',
        'View the chart anyway': 'Visualizar o gráfico mesmo assim',
        Trajectory: 'Trajetória',
        'True Vertical Depth': 'Profundidade Vertical',
        'Equivalent Departure': 'Deslocamento Horizontal',
        Lithology: 'Litologia',
        'Zoom Options': 'Opções de Zoom',
        'Entire Well': 'Poço Inteiro',
        Free: 'Livre',
        'Wellbore Stability': 'Estabilidade de Poço',
        'Sync tooltip': 'Sincronizar tooltip',
        'Follow Bit Depth': 'Acompanhar Broca'
    }
}
